const hasSome = (array, options) => Array.isArray(array) && array.some(item => options.includes(item));

export const physicalDisability = {
	title: 'Deficiência Física',
	value: 'Physical Disability',
	steps: [
		{
			field: 'physicalDisabilityType',
			order: 1,
			type: 'check',
			label: 'Tipo de deficiência física',
			choices: ['Membros inferiores', 'Membros superiores', 'Membros inferiores e superiores', 'Fala e/ou Fonação', 'Nanismo', 'Ostomia', 'Outros'],
			dependency: () => true,
		},
		{
			field: 'physicalDisabilityTypeOther',
			order: 2,
			type: 'textarea',
			label: 'Descreva a sua deficiência',
			dependency: data => hasSome(data.physicalDisabilityType, ['Outros']),
		},
		{
			field: 'difficultyGettingAround',
			order: 3,
			type: 'boolean',
			label: 'Você possui alguma dificuldade para se locomover?',
			dependency: data => hasSome(data.physicalDisabilityType, ['Membros inferiores', 'Membros inferiores e superiores']),
		},
		{
			field: 'accessibilityFeatureToGetAround',
			order: 4,
			type: 'check',
			label: 'Você usa algum recurso de acessibilidade para se locomover?',
			choices: ['Cadeira de rodas', 'Muletas', 'Andador', 'Bengala', 'Outro', 'Não'],
			dependency: data => data.difficultyGettingAround === true,
		},
		{
			field: 'accessibilityFeatureToGetAroundOther',
			order: 5,
			type: 'textarea',
			label: 'Descreva o recurso que você utiliza',
			dependency: data => hasSome(data.accessibilityFeatureToGetAround, ['Outro']),
		},
		{
			field: 'lowerLimbsLimitationRestriction',
			order: 6,
			type: 'boolean',
			label: 'Você possui alguma limitação ou restrição devido a seus membros inferiores?',
			dependency: data => hasSome(data.physicalDisabilityType, ['Membros inferiores', 'Membros inferiores e superiores']) && !hasSome(data.accessibilityFeatureToGetAround, ['Cadeira de rodas']),
		},
		{
			field: 'limitationOrRestrictionDescription',
			order: 7,
			type: 'check',
			label: 'Qual a limitação ou restrição?',
			choices: [
				'Manco ao caminhar/ caminho em um ritmo mais lento',
				'Não posso ficar muito tempo em pé',
				'Posso ficar em pé, mas preciso de intervalos para sentar',
				'Não posso caminhar longos trajetos com frequência',
				'Tenho dificuldade para subir e/ou descer escadas',
				'Não posso carregar peso maior que 5kg',
				'Outro',
			],
			dependency: data => data.lowerLimbsLimitationRestriction === true && !hasSome(data.accessibilityFeatureToGetAround, ['Cadeira de rodas']),
		},
		{
			field: 'limitationOrRestrictionDescriptionOther',
			order: 8,
			type: 'textarea',
			label: 'Descreva a limitação ou restrição',
			dependency: data => hasSome(data.limitationOrRestrictionDescription, ['Outro']),
		},
		{
			field: 'upperLimbsLimitationRestriction',
			order: 9,
			type: 'boolean',
			label: 'Você possui alguma limitação ou restrição devido a seus membros superiores?',
			dependency: data => hasSome(data.physicalDisabilityType, ['Membros superiores', 'Membros inferiores e superiores']),
		},
		{
			field: 'upperLimbsLimitationRestrictionDescription',
			order: 10,
			type: 'check',
			label: 'Qual a limitação ou restrição?',
			choices: [
				'Não posso carregar peso',
				'Tenho menor habilidade para carregar objetos',
				'Não tenho força na mão',
				'Tenho dificuldade de fala',
				'Tenho menor habilidade de digitação',
				'Não tenho movimento de pinça/garra da mão',
				'Tenho movimento limitado no(s) braços',
				'Não faço movimento de rotação no ombro/braço',
				'Outros',
			],
			dependency: data => data.upperLimbsLimitationRestriction === true,
		},
		{
			field: 'upperLimbsLimitationRestrictionDescriptionOther',
			order: 11,
			type: 'textarea',
			label: 'Descreva a limitação ou restrição',
			dependency: data => hasSome(data.upperLimbsLimitationRestrictionDescription, ['Outros']),
		},
		{
			field: 'needAdaptationWorkEnvironment',
			order: 12,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: data => hasSome(data.physicalDisabilityType, ['Membros superiores', 'Membros inferiores e superiores', 'Fala e/ou Fonação', 'Nanismo', 'Ostomia', 'Outros']),
		},
		{
			field: 'needAdaptationWorkEnvironmentDescription',
			order: 13,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.needAdaptationWorkEnvironment === true,
		},
	],
};

export const hearingImpairment = {
	title: 'Deficiência Auditiva',
	value: 'Hearing Impairment',
	steps: [
		{
			field: 'hearingImpairmentDescription',
			order: 1,
			type: 'check',
			label: 'Descreva a sua deficiência',
			choices: ['Surdo(a)', 'Perda auditiva bilateral, moderada ou severa', 'Perda auditiva unilateral total'],
			dependency: () => true,
		},
		{
			field: 'communicationCharacteristics',
			order: 2,
			type: 'check',
			label: 'Característica da comunicação',
			choices: ['Sou oralizado(a)', 'Faço leitura labial', 'Me comunico em LIBRAS', 'Me comunico por telefone', 'Me comunico por mensagem, whatsapp e e-mail', 'Outro'],
			dependency: data => hasSome(data.hearingImpairmentDescription, ['Surdo(a)', 'Perda auditiva bilateral, moderada ou severa', 'Perda auditiva unilateral total']),
		},
		{
			field: 'hearingImpairmentAdaptationWork',
			order: 3,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: data =>
				hasSome(data.communicationCharacteristics, [
					'Sou oralizado(a)',
					'Faço leitura labial',
					'Me comunico em LIBRAS',
					'Me comunico por telefone',
					'Me comunico por mensagem, whatsapp e e-mail',
					'Outro',
				]),
		},
		{
			field: 'hearingImpairmentAdaptationWorkDescription',
			order: 4,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.hearingImpairmentAdaptationWork === true,
		},
	],
};

export const visualImpairment = {
	title: 'Deficiência Visual',
	value: 'Visual Impairment',
	steps: [
		{
			field: 'visualImpairmentDescription',
			order: 1,
			type: 'check',
			label: 'Descreva sua deficiência',
			choices: ['Tenho visão monocular', 'Tenho baixa visão', 'Sou uma pessoa cega'],
			dependency: () => true,
		},
		{
			field: 'visualImpairmentLimitationRestriction',
			order: 2,
			type: 'boolean',
			label: 'Você possui alguma limitação ou restrição?',
			dependency: () => true,
		},
		{
			field: 'visualImpairmentLimitationRestrictionDescription',
			order: 3,
			type: 'textarea',
			label: 'Descreva a limitação ou restrição',
			dependency: data => data.visualImpairmentLimitationRestriction === true,
		},
		{
			field: 'visualImpairmentAdaptationWork',
			order: 4,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: () => true,
		},
		{
			field: 'visualImpairmentAdaptationWorkDescription',
			order: 5,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.visualImpairmentAdaptationWork === true,
		},
	],
};

export const intellectualDisability = {
	title: 'Deficiência Intelectual',
	value: 'Intellectual Disability',
	steps: [
		{
			field: 'intellectualDisabilityDescription',
			order: 1,
			type: 'textarea',
			label: 'Descrição da deficiência',
			dependency: () => true,
		},
		{
			field: 'intellectualDisabilityAdaptationWork',
			order: 2,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: () => true,
		},
		{
			field: 'intellectualDisabilityAdaptationWorkDescription',
			order: 3,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.intellectualDisabilityAdaptationWork === true,
		},
	],
};

export const psychosocialDisability = {
	title: 'Deficiência Psicossocial',
	value: 'Psychosocial Disability',
	steps: [
		{
			field: 'psychosocialDisabilityDescription',
			order: 1,
			type: 'textarea',
			label: 'Descrição da deficiência',
			dependency: () => true,
		},
		{
			field: 'psychosocialDisabilityAdaptationWork',
			order: 2,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: () => true,
		},
		{
			field: 'psychosocialDisabilityAdaptationWorkDescription',
			order: 3,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.psychosocialDisabilityAdaptationWork === true,
		},
	],
};

export const autismSpectrum = {
	title: 'Transtorno do Espectro Autista',
	value: 'Autism Spectrum Disorder',
	steps: [
		{
			field: 'autismSpectrumDescription',
			order: 1,
			type: 'textarea',
			label: 'Descrição da deficiência',
			dependency: () => true,
		},
		{
			field: 'autismSpectrumAdaptationWork',
			order: 2,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: () => true,
		},
		{
			field: 'autismSpectrumAdaptationWorkDescription',
			order: 3,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.autismSpectrumAdaptationWork === true,
		},
	],
};

export const rehabilitationINSS = {
	title: 'Reabilitado do INSS',
	value: 'Rehabilitation INSS',
	steps: [
		{
			field: 'rehabilitationCertified',
			order: 1,
			type: 'boolean',
			label: 'Você possui o certificado de reabilitação do INSS?',
			dependency: () => true,
		},
		{
			field: 'didRehabilitationCourse',
			order: 2,
			type: 'boolean',
			label: 'Você realizou algum curso de reabilitação?',
			dependency: data => data.rehabilitationCertified === true,
		},
		{
			field: 'rehabilitationCourse',
			order: 3,
			type: 'textarea',
			label: 'Qual curso de reabilitação você realizou?',
			dependency: data => data.didRehabilitationCourse === true,
		},
		{
			field: 'rehabilitationAdaptationWork',
			order: 4,
			type: 'boolean',
			label: 'Você precisa de adaptação no ambiente de trabalho?',
			dependency: () => true,
		},
		{
			field: 'rehabilitationAdaptationWorkDescription',
			order: 5,
			type: 'textarea',
			label: 'Descreva a adaptação',
			dependency: data => data.rehabilitationAdaptationWork === true,
		},
	],
};
